module.exports = __webpack_public_path__ + "static/img/loading.949ecc0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/loading.gif
// module id = wOw2
// module chunks = 1